import { Controller } from "@hotwired/stimulus"

// Lightweight image gallery controller for product pages.
// Handles switching the main image when clicking thumbnails.
// Works within a single tag/colorway — tag switching is handled
// server-side via Turbo Frame replacement.
export default class extends Controller {
  static targets = ["mainImage", "thumbnail", "colorLabel"]

  switchImage(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const src = btn.dataset.src
    const fullSrc = btn.dataset.fullSrc
    const color = btn.dataset.color

    // Update main image
    if (this.hasMainImageTarget) {
      this.mainImageTarget.src = fullSrc || src
    }

    // Update color label
    if (this.hasColorLabelTarget && color) {
      this.colorLabelTarget.innerHTML = `Color: <span class="font-medium text-gray-900 dark:text-white">${color}</span>`
      this.colorLabelTarget.classList.remove("hidden")
    }

    // Highlight active thumbnail. Tailwind classes for the legacy
    // _image_gallery.html.erb partial; `on` class for the design_v2
    // .gallery-strip .thumb.on rule used on the product show page.
    this.thumbnailTargets.forEach(t => {
      t.classList.toggle("on", t === btn)
      t.classList.toggle("ring-2", t === btn)
      t.classList.toggle("ring-blue-500", t === btn)
      t.classList.toggle("border-blue-500", t === btn)
      t.classList.toggle("border-gray-200", t !== btn)
      t.classList.toggle("dark:border-gray-600", t !== btn)
    })
  }
}
